package com.eladfinish.bible.contest.screens.search.engine

data class ChapterSearchResult(
    val matches: List<ChapterSearchMatch>,
    val bookName: String,
    val chapterName: String,
)

data class ChapterSearchMatch(
    val bookIndex: Int,
    val bookName: String,
    val chapterName: String,
    val verseNumber: String,
    val verseContent: String,
    val source: String,
    val capturedGroups: List<String>,
    val groupRanges: List<IntRange>,
)

internal data class ParsedChapterVerse(
    val verseNumber: String,
    val rawContent: String,
)
